import { useInfiniteQuery } from '@tanstack/react-query';

import { fetchCursorNotifications } from '../services';
import type { NotificationStatusFilter } from '../types';

type UseCursorNotificationListParams = {
  limit: number;
  status: Extract<NotificationStatusFilter, 'all' | 'unread'>;
};

export function useCursorNotificationList({ limit, status }: UseCursorNotificationListParams) {
  return useInfiniteQuery({
    queryKey: ['notifications', 'cursor-list', limit, status],
    initialPageParam: null as string | null,
    queryFn: ({ pageParam }) =>
      fetchCursorNotifications({
        limit,
        cursor: pageParam,
        is_read: status === 'unread' ? false : undefined,
      }),
    getNextPageParam: lastPage => {
      if (lastPage.pagination.type !== 'cursor') {
        return undefined;
      }

      const pagination = lastPage.pagination;
      return pagination.has_more ? pagination.next_cursor : undefined;
    },
  });
}
